"use strict";

import Vue from "vue";
import axios from "axios";
import { serverBus } from "../main";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: process.env.VUE_APP_SKOLE_API_URL || "",
  // timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
  headers: {
    Accept: "application/json",
  }, // Check cross-site Access-Control
};

const baseUrl = process.env.VUE_APP_SKOLE_API_URL;
const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    config.headers["role-id"] = localStorage.getItem("role_id");
    config.headers["organisation-id"] = localStorage.getItem("organisation_id");
    config.headers["organisation-type"] = localStorage.getItem(
      "organisation_type"
    );
    config.headers["school-id"] = localStorage.getItem("school_id");
    config.headers["school-year-id"] = localStorage.getItem("school_year_id");
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    const code = parseInt(error.response && error.response.status);
    if (code === 401) {
      window.location.href = `${baseUrl}sso/login?redirect_to=${location.href}`;
    }

    if (code === 403) {
      serverBus.$emit(
        "show-snackbar",
        false,
        "Nemate dozvolu za pristup ovom dijelu sustava!"
      );
    }

    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        console.log(options); // TODO (custom): izbriši ovo..
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

axios.defaults.baseURL = baseUrl;
axios.defaults.withCredentials = true;
axios.defaults.headers.accept = "application/json";

export default Plugin;
